import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ProfileStatsProps } from "../types";

export const ProfileStats = ({ portfolioCount, profileId }: ProfileStatsProps) => {
  const { data: followerCount = 0 } = useQuery({
    queryKey: ["followerCount", profileId],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('get_follower_count', { profile_id: profileId });
      
      if (error) throw error;
      return data;
    },
    enabled: !!profileId,
  });

  return (
    <div className="flex gap-10">
      <div className="text-center">
        <span className="font-semibold">{portfolioCount}</span>{" "}
        <span>projects</span>
      </div>
      <div className="text-center">
        <span className="font-semibold">{followerCount}</span>{" "}
        <span>followers</span>
      </div>
      <div className="text-center">
        <span className="font-semibold">0</span> <span>endorsements</span>
      </div>
    </div>
  );
};